module.exports = __webpack_public_path__ + "img/28.1719f0d.jpg";